var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopSortIocn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.4 15.7167C10.2 15.9833 9.8 15.9833 9.6 15.7167L6.85 12.05C6.60279 11.7204 6.83798 11.25 7.25 11.25H12.75C13.162 11.25 13.3972 11.7204 13.15 12.05L10.4 15.7167Z",
    fill: "#534FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4.28333C10.2 4.01667 9.8 4.01667 9.6 4.28333L6.85 7.95C6.60279 8.27962 6.83798 8.75 7.25 8.75H12.75C13.162 8.75 13.3972 8.27962 13.15 7.95L10.4 4.28333Z",
    fill: "#534FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSortIocn);
export default __webpack_public_path__ + "static/media/topSortIocn.57854dc0fa68a14fcb869730b2f2d309.svg";
export { ForwardRef as ReactComponent };